const AWS_DOMAIN = 'amazonaws.com';

export function isS3(url: string): boolean {
  return url.includes(AWS_DOMAIN);
}
